export class VisitorChild {

  fullName: string | any;


  constructor() {
    this.fullName = '';
  }
}
